import "cally";

// Destination-page booking calendar. The picked range lives in the URL as
// ?from=YYYY-MM-DD&to=YYYY-MM-DD and all availability filtering of the product
// list happens server-side (see product_list_render_callback). So picking a
// range just reloads the page with the date params, and resetting reloads the
// page without them.
const calendarContainer = document.querySelector('.calendar-container');
const calendarIcon = calendarContainer ? calendarContainer.querySelector('.book_calendar') : null;
const calendar = calendarContainer ? calendarContainer.querySelector('calendar-range') : null;
const cancelSelection = document.querySelector('.cancel-date-selection');

// Toggle the calendar panel open/closed, keeping aria-expanded in sync.
if (calendarIcon && calendar) {
    calendarIcon.addEventListener('click', function () {
        const isHidden = calendar.classList.toggle('hidden');
        calendarIcon.setAttribute('aria-expanded', String(!isHidden));
        if (!isHidden) {
            calendar.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    });
}

// Picking a range reloads the page with the dates as query params; the server
// renders the availability-filtered product list.
if (calendar) {
    calendar.addEventListener('change', function (event) {
        const [from, to] = event.target.value.split('/');
        if (!from || !to) {
            return;
        }
        const url = new URL(window.location);
        url.searchParams.set('from', from);
        url.searchParams.set('to', to);
        window.location.assign(url);
    });
}

// Resetting clears the date params and returns to the unfiltered page.
if (cancelSelection) {
    cancelSelection.addEventListener('click', function () {
        const url = new URL(window.location);
        url.searchParams.delete('from');
        url.searchParams.delete('to');
        window.location.assign(url);
    });
}
